export default function TasteSection() {
  return (
    <section className="bg-[#FFD93D] py-24 md:py-36 px-8 md:px-16 overflow-hidden">
      <div className="w-full">
        {/* Big centered statement */}
        <div className="text-center mb-20">
          <h2
            className="text-black font-black uppercase leading-none"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 10vw, 140px)' }}
          >
            FAST.
            <br />
            RELIABLE.
            <br />
            <span className="text-[#FF6B35]">SCALABLE.</span>
          </h2>
          <p className="text-black/70 font-bold text-xl md:text-3xl mt-8 uppercase tracking-widest">
            The values that drive every project we deliver.
          </p>
        </div>

        {/* Value cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              icon: 'ri-rocket-line',
              title: 'SPEED & DELIVERY',
              desc: 'We move fast without sacrificing quality. Agile sprints, clear milestones, and regular demos keep projects on schedule.',
              bg: 'bg-[#FF8C42]',
              text: 'text-white',
            },
            {
              icon: 'ri-eye-line',
              title: 'FULL TRANSPARENCY',
              desc: 'You always know where your project stands. Real-time updates, open communication, and no surprises — ever.',
              bg: 'bg-black',
              text: 'text-white',
            },
            {
              icon: 'ri-settings-3-line',
              title: 'CUSTOM BUILT',
              desc: 'No copy-paste solutions. Every line of code, every design decision is tailored specifically to your business needs.',
              bg: 'bg-[#FF6B35]',
              text: 'text-white',
            },
            {
              icon: 'ri-line-chart-line',
              title: 'GROWTH FOCUSED',
              desc: 'We don\'t just ship and disappear. Our solutions are designed to scale with your business and adapt to change.',
              bg: 'bg-[#1A1A1A]',
              text: 'text-white',
            },
          ].map((item) => (
            <div key={item.title} className={`${item.bg} rounded-[30px] p-8 md:p-10`}>
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mb-6">
                <i className={`${item.icon} ${item.text} text-3xl`} />
              </div>
              <h3
                className={`${item.text} font-black uppercase text-2xl md:text-3xl mb-4 leading-tight`}
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                {item.title}
              </h3>
              <p className={`${item.text} opacity-80 font-semibold text-base md:text-lg leading-relaxed`}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Tagline */}
        <div className="mt-20 text-center">
          <div className="inline-block border-4 border-black rounded-full px-12 py-6">
            <p
              className="text-black font-black uppercase"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(24px, 3vw, 48px)' }}
            >
              "YOUR SUCCESS IS OUR KPI"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
